import api from './index'
import request from '@/utils/request'
/**
 * @description 风控工单列表
 */
export function riskList (data) {
  return request({
    url: `${api.riskList}`,
    method: 'post',
    data
  })
}
/**
 * @description 风控工单详情
 */
export function riskTicketsDetail (data) {
  return request({
    url: `${api.riskTicketsDetail}`,
    method: 'post',
    data
  })
}
/**
 * @description 风控工单批量导出
 */
export function exportRiskTickets (data) {
  return request({
    url: `${api.exportRiskTickets}`,
    method: 'post',
    data
  })
}
/**
 * @description 风控工单申诉模板详情
 */
export function riskTicketsFormDetails (data) {
  return request({
    url: `${api.riskTicketsFormDetails}`,
    method: 'post',
    data
  })
}
/**
 * @description 风控工单查询资料不合格项
 */
export function checkNoPassItem (data) {
  return request({
    url: `${api.checkNoPassItem}`,
    method: 'post',
    data
  })
}
/**
 * @description 风控工单在线申诉模板提交
 */
export function commitRiskTicket (data) {
  return request({
    url: `${api.commitRiskTicket}`,
    method: 'post',
    data
  })
}
/**
 * @description 风控工单人工申诉提交
 */
export function offlineCheck (data) {
  return request({
    url: `${api.offlineCheck}`,
    method: 'post',
    data
  })
}
/**
 * @description 风控工单在线申诉提交
 */
export function manualAppealCommit (data) {
  return request({
    url: `${api.manualAppealCommit}`,
    method: 'post',
    data
  })
}
